module.exports = __webpack_public_path__ + "img/sk.e88084dd.svg";